import React, { FC, ComponentType, createElement } from 'react'
import { Route, Redirect, useLocation, RouteProps } from 'react-router-dom'

interface ProtectedRouteBuilder {
  (predicate: () => boolean, redirectPath: string): FC<RouteProps>
}

const ProtectedRouteBuilder: ProtectedRouteBuilder =
  (predicate, redirectPath) =>
  ({ component, ...rest }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const location = useLocation()
    return (
      <Route
        {...rest}
        render={props =>
          predicate() ? (
            createElement(component as ComponentType<any>, props)
          ) : (
            <Redirect
              exact
              to={{
                pathname: redirectPath,
                search: `?redirect=${encodeURIComponent(location.pathname + location.search)}`,
                state: location.state,
              }}
            />
          )
        }
      />
    )
  }

export default ProtectedRouteBuilder
